"use strict";
/*
    Add here your own custom javascript
*/
const preloadImage = (url) => {
    let img = new Image();
    img.src = url;
    console.info('preloaded: ' + url)
}

const styleAllElements = (elements, styleProperty, styleValue) => {
    for (let x = 0; elements.length > x; x++) {
        elements[x].style[styleProperty] = styleValue
    }
}

// clears text selection
const clearSelection = () => {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
}

// tool to make iframe videos max-width
const mediaWrapper = (selector) => {
    const wrap = (toWrap, wrapper) => {
        wrapper = wrapper || document.createElement('div');
        wrapper.classList.add('mediaWrapper')
        toWrap.parentNode.appendChild(wrapper)
        return wrapper.appendChild(toWrap)
    };

    const elements = document.querySelectorAll(selector);

    if (elements.length > 0) {
        elements.forEach((element) => {
            wrap(element)
        })
    }
}

const lightbox = () => {
    let lightboxElement = null;

    const closeLightbox = () => {
        if (this.lightboxElement.style.display !== "none")
            this.lightboxElement.style.display = "none"
    }

    const attachOpenLightboxEvent = (linkElement) => {
        linkElement.addEventListener('click', openLightbox)
    }

    const loadImage = src => new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })

    const openLightbox = (event) => {
        let target = event.target
        let imageUrl = target.getAttribute('src')

        // console.log(`imageUrl`, imageUrl)

        this.imageElement = this.lightboxElement.querySelector('.lightbox--image-container img')
        this.imageElement.style.display = "none"
        this.lightboxElement.classList.add('loading')
        this.lightboxElement.style.display = "block"

        loadImage(imageUrl).then(image => {
            // console.log(image, `loaded: ${image.complete}`)
            this.imageElement.src = imageUrl
            this.imageElement.style.display = "block"
            if (this.lightboxElement.classList.contains('loading')) {
                this.lightboxElement.classList.remove('loading')
            }
        })
    }
    return {
        init: () => {
            this.lightboxElement = document.querySelector('div#lightbox')
            this.closeElement = this.lightboxElement.querySelector('button.close')
            this.imageElement = this.lightboxElement.querySelector('img')
            this.imageElement.addEventListener('click', closeLightbox)
            this.closeElement.addEventListener('click', closeLightbox)
            // esc to close
            document.addEventListener('keyup', (e) => {
                if (e.key === "Escape") {
                    closeLightbox()
                }
            })

            let lightboxLinks = document.querySelectorAll("a[data-toggle='lightbox']")
            if (lightboxLinks) {
                lightboxLinks.forEach((linkElement) => {
                    attachOpenLightboxEvent(linkElement)
                })
            }
        }
    }
}

let productColorSlider;

(function () {
    lightbox().init();

    mediaWrapper('iframe[src*=youtube], iframe[src*=vimeo]')

    let productThumbnailSlider = new Swiper('.product-thumbnail-slider', {
        direction: 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        mousewheel: true
    });

    let productImagesSlider = new Swiper('.product-image-slider', {
        slidesPerView: 1,
        mousewheel: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        navigation: {
            nextEl: '.product-image-slider-wrapper .swiper-button-next',
            prevEl: '.product-image-slider-wrapper .swiper-button-prev',
        }
    });

    let productThumbnailSliderElement = document.querySelector('.product-thumbnail-slider');

    productThumbnailSlider.on("slideChange", () => {
        productImagesSlider.slideTo(productThumbnailSlider.activeIndex);
    });

    productImagesSlider.on("slideChange", () => {
        productThumbnailSlider.slideTo(productImagesSlider.activeIndex);
        productThumbnailSliderElement.querySelector('.swiper-slide-active').classList.remove('swiper-slide-active');
        productThumbnailSliderElement.querySelectorAll('.swiper-slide')[productImagesSlider.activeIndex].classList.add('swiper-slide-active');
    });

    // Add click event to the thumbnail slider
    productThumbnailSlider.on('click', function () {
        productImagesSlider.slideTo(productThumbnailSlider.clickedIndex);
        productThumbnailSliderElement.querySelector('.swiper-slide-active').classList.remove('swiper-slide-active');
        productThumbnailSliderElement.querySelectorAll('.swiper-slide')[productImagesSlider.activeIndex].classList.add('swiper-slide-active');
    });

    productColorSlider = new Swiper('.product-color-slider', {
        slidesPerView: 'auto',
        // slideToClickedSlide: true,
        spaceBetween: 10,
        loopedSlides: 50,
        simulateTouch: false,
        mousewheel: {
            invert: false
        },
        // Navigation arrows
        navigation: {
            nextEl: document.querySelector(".product-color-slider-wrapper .swiper-button-next"),
            prevEl: document.querySelector(".product-color-slider-wrapper .swiper-button-prev")
        }
    });

    let productColorSliderInput = document.querySelectorAll('.product-color-slider input[type=radio]');
    let productColorSliderSelectedOptionText = document.querySelector('.product-option-name .selected-option-text');

    // set text field when input selected
    productColorSliderInput.forEach((input) => {
        input.addEventListener('change', event => {
            // console.log(`event.target.value`, event.target.value);
            productColorSliderSelectedOptionText.innerText = event.target.value;
        })
    })

    let addonProductSlider = new Swiper('.addon-product-slider', {
        slidesPerView: 'auto',
        // slideToClickedSlide: true,
        spaceBetween: 20,
        // loopedSlides: 50,
        simulateTouch: false,
        // Navigation arrows
        navigation: {
            nextEl: document.querySelector(".addon-product-slider-wrapper .swiper-button-next"),
            prevEl: document.querySelector(".addon-product-slider-wrapper .swiper-button-prev")
        }
    });

    let featuredProductSwiperElement = document.querySelector('.featured-products-carousel')
    if (featuredProductSwiperElement) {
        new Swiper('.featured-products-carousel .swiper', {
            // Optional parameters
            direction: "horizontal",
            loop: false,
            autoplay: false,
            slidesPerView: 3,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                // when window width is >= 480px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                // when window width is >= 640px
                992: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                // when window width is >= 1680px
                1680: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
            },
            // Navigation arrows
            navigation: {
                nextEl: featuredProductSwiperElement.querySelector(".swiper-button-next"),
                prevEl: featuredProductSwiperElement.querySelector(".swiper-button-prev")
            }
        })
    }

    const navBarOffCanvas = document.querySelector('#navbar-offcanvas')
    const toggler = document.querySelector('#navbar .navbar-toggler')
    navBarOffCanvas.addEventListener('show.bs.offcanvas', event => {
        if (!toggler.classList.contains('active')) {
            toggler.classList.add('active')
        }
    })
    navBarOffCanvas.addEventListener('hide.bs.offcanvas', event => {
        if (toggler.classList.contains('active')) {
            toggler.classList.remove('active')
        }
    })

    // auto play and auto pause for home video modal
    const iframe = document.getElementById('home--video-modal-iframe');
    const homeVideoModal = document.getElementById('home--video-modal')
    if (homeVideoModal) {
        homeVideoModal.addEventListener('shown.bs.modal', event => {
            // only auto play when on desktop
            if (window.innerWidth >= 992) {
                iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
            }
        })
        homeVideoModal.addEventListener('hidden.bs.modal', event => {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        })
    }

})();

/**
 * Implements dynamic form validation for '.form-wholesale'.
 * Validates fields based on 'data-validations' attribute, 
 * applying 'error' class on validation failure. Prevents
 * form submission if any validation fails, focusing the first 
 * invalid field. Supports comma-separated validation rules
 * like 'required', 'email', etc. Now also supports 'required'
 * validation for select fields, ensuring a selection is made.
 */
document.addEventListener('DOMContentLoaded', function () {
    const insightlyWholesaleForm = document.querySelector('.form-wholesale');

    if (insightlyWholesaleForm) {
        insightlyWholesaleForm.addEventListener('submit', function (event) {
            const controls = insightlyWholesaleForm.querySelectorAll('[data-validations]');
            let isFormValid = true;

            controls.forEach(control => {
                const validations = control.dataset.validations.split(',').map(v => v.trim());
                let isFieldValid = true;

                // Initially remove the 'error' class to reset the state from previous checks
                control.classList.remove('error');

                for (let validation of validations) {
                    if (!validateField(control, validation)) {
                        // If validation fails, add 'error' class and mark field and form as invalid
                        control.classList.add('error');
                        isFieldValid = false;
                        isFormValid = false;
                        break; // Exit the validation loop on the first failure
                    }
                }
            });

            if (!isFormValid) {
                event.preventDefault(); // Prevent form submission if there are invalid fields
                // Optional: Focus the first invalid field for user convenience
                insightlyWholesaleForm.querySelector('.error')?.focus();
            }
        });
    }
});

function validateField(field, validationType) {
    switch (validationType) {
        case 'required':
            if (field.type === 'select-multiple') {
                // For multi-select, check if any option is selected
                return Array.from(field.options).some(option => option.selected);
            }
            return field.value.trim() !== '';
        case 'email':
            return /^.+\@.+\..+$/.test(field.value);
        default:
            return true; // Assume field is valid if the validation type is unknown
    }
}

// Attaches an event to the search form to format user input into
// exact phrase search queries by enclosing the input in quotes.
document.addEventListener('DOMContentLoaded', function() {
    const searchForm = document.querySelector('#template-search');
    if (searchForm) {
        const searchInput = searchForm.querySelector('input[name="q"]');

        searchForm.addEventListener('submit', function(event) {
            let searchTerms = searchInput.value.trim();

            // Strip existing enclosing quotes
            searchTerms = searchTerms.replace(/^"|"$/g, '');

            // Enclose the search terms in quotes
            searchTerms = `"${searchTerms}"`;

            searchInput.value = searchTerms;

            // No need to explicitly call event.preventDefault() as we want the form to submit
            // The form will naturally submit with the modified search terms
        });
    }
});
